class LqdModalHandler extends elementorModules.frontend.handlers.Base {

	onInit( ...args ) {

		super.onInit( ...args );

		const modelCID = this.getModelCID();
		this.modelSettings = elementorFrontend.config.elements.data[ modelCID ];

		this.handleDestroy();

		this.initModal();

	}

	getDefaultSettings() {
		return {
			selectors: {
				modalElement: 'lqd-modal',
				triggerElement: `[data-lqd-lity=#modal-${ this.getElementSettings().modal }]`
			}
		}
	}

	getDefaultElements() {
		const selectors = this.getSettings( 'selectors' );
		return {
			$modalElement: this.$element.find( selectors.modalElement ),
			$triggerElement: elementorFrontend.elements.$body.find( selectors.triggerElement ),
		}
	}

	onElementChange( prop ) {

		if (
			prop === 'modal' ||
			prop === 'content_type'
		) {
			this.handleModalChange();
		}
	}

	initModal() {

		this.elements.$triggerElement.liquidLightBox();

	}

	handleModalChange() {
		const idEl = elementor.panel.el.querySelector( '.lqd-modal-id' );
		const modal = this.modelSettings.get( 'modal' );
		const content_type = this.modelSettings.get( 'content_type' );

		if ( idEl ) {
			idEl.querySelector( '.lqd-modal-id' ).innerText = ( content_type === 'el_template' && modal != 0 ) ? modal : this.getID();
			idEl.animate( [
				{ transform: 'scale(1.25)', filter: 'blur(7px)', opacity: 0 },
				{ transform: 'scale(1)', filter: 'blur(0)', opacity: 1 },
			], {
				duration: 350,
				easing: 'ease'
			} );
		}

	}

	onDestroy() {

		this.handleDestroy();

		super.onDestroy();

	}

	handleDestroy() {

		this.handleModalDestroy();

	}

	handleModalDestroy() {

		if ( !this.elements.$triggerElement.length ) return;

		const modalData = this.elements.$triggerElement.data( 'plugin_liquidLightBox' );

		if ( modalData ) {
			modalData.destroy();
		}

	}

}

export default ( $element ) => {
	elementorFrontend.elementsHandler.addHandler( LqdModalHandler, { $element } );
};